import React, {useEffect} from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import Login from "./components/Login";
import Projects from "./components/projects_page/Projects";
import ProjectDetail from "./components/project_detail_page/ProjectDetail";
import { API_BASE_URL } from "./constants";
import axios from "axios";

import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";


function App() {
    return (
    <I18nProvider i18n={i18n}>
        <Router>
            <Routes>
                {/* 23/10/2026: de wortel ging naar een ingebedde kopie van de oude website,
                    waardoor de werkers een lege pagina zagen. De app start nu op de login.
                    Vraag van Bartel: "Werkt niet" bij het openen van het nieuwe adres. */}
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="/diensten" element={<StaticPage url="diensten/" />} />
                <Route path="/contact" element={<StaticPage url="contact/" />} />
                <Route path="/privacy-verklaring" element={<StaticPage url="privacy-verklaring/" />} />
                <Route path="/login" element={<Login />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/:id" element={<ProjectDetail />} />
            </Routes>
        </Router>
    </I18nProvider>
    );
};

function StaticPage({ url }) {
    const navigate = useNavigate();

    useEffect(() => {
        window.addEventListener('message', (event) => {
        if (event.data.type === 'navigate') {
            navigate(event.data.url);
        } else if (event.data.type === 'email') {
            const data = {
                "full_name": event.data.full_name,
                "telephone": event.data.phone_number,
                "sender": event.data.email,
                "message": event.data.message,
            }

            axios.post(API_BASE_URL + "email/", data, {
                headers: {
                  "Content-Type": "application/json",
                },
            });
            
        }
        });

        return () => {
        window.removeEventListener('message', (event) => {});
        };
    }, [navigate]);



    return (
        <iframe
            src={`/renoperfect/RenoPerfect/renoperfect/${url}index.html`}
            title="Statische HTML Pagina"
            width="100%"
            style={{ position: "absolute", height: "100%", border: "none" }}
      />
    )
}

export default App;
